
const key = "role";
const RoleService = {
    setRole(data: any) {
        try {
            if (data instanceof Object)
                data = JSON.stringify(data);
            data = (data.toLocaleLowerCase());
            localStorage.setItem(key, data);
        } catch (e) {
            console.error(e);
        }
    },
    getRole() {
        try {
            let data = localStorage.getItem(key);
            data = data ?? null;
            if (data != null)
                data = (data);
            return data;
        } catch (e) {
            console.error(e);
        }
        return null;
    },
    isAdmin() {
        let data = this.getRole();
        if (data != null)
            return (data == "admin_user");
        return false;
    },
    isClient() {
        let data = this.getRole();
        if (data != null)
            return (data == "consent");
        return false;
    },
    hasAnyRole(roles: any) {
        let data = this.getRole();
        if (data != null && roles.length > 0) {
            for (let i = 0; i < roles.length; i++) {
                let role = roles[i];
                return (data == role);
            }
        }
        return false;
    },
}

// string to integer
function sti(str: any) {
    return (str.split('').map((char: any) => char.charCodeAt(0)).join('.'));
}

// integer to string
function its(num: any) {
    return num.split('.').map((digit: any) => String.fromCharCode(Number(digit))).join('');
}

export default RoleService;